module.exports = "query GetBanners {\n  banners {\n    id\n    title\n    htmlContent\n    createdAt\n    updatedAt\n  }\n}\n"